// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getErrorMessage = (error: Error | any, defaultMessage: string) => {
  return (
    error.response?.data?.message ??
    error?.response?.data?.error ??
    error.message ??
    defaultMessage
  );
};
